import { Link } from "react-router-dom";

export const Logo = ({ onClick }) => (
  <Link to="/" onClick={onClick} className="group flex items-center gap-3" data-testid="header-logo-link" aria-label="WeeLogRun home">
    <img src="/brand/weelogrun-160.png" alt="WeeLogRun Firewood Subscription logo" width="52" height="52" className="h-12 w-12 sm:h-[52px] sm:w-[52px] shrink-0 rounded-full transition-transform duration-300 group-hover:rotate-[-6deg]" />
    <span className="leading-none">
      <span className="block font-display text-lg font-extrabold tracking-tight text-[#F7F5F0]">
        <span className="text-[#D4A437]">WEE</span>LOG<span className="text-[#FF6A00]">RUN</span>
      </span>
      <span className="mt-1 block whitespace-nowrap text-[9px] sm:text-[10px] font-semibold uppercase tracking-[0.12em] sm:tracking-[0.2em] text-[#FF6A00]">
        Newtownabbey Log Delivery
      </span>
    </span>
  </Link>
);
